import React, { useRef, useContext } from 'react'
import { useTheme } from '@emotion/react'
import { useSearchBox } from 'react-instantsearch'
import searchIconWhite from '../images/svgs/search-icon-white.svg'
import { navigate } from 'gatsby'
import AppContext from './context'

export default function Search({ onClick, overlay, style }) {
    const { clientWidth } = useContext(AppContext)
    const { query, refine, clear } = useSearchBox()
    const inputRef = useRef(null)
    const theme = useTheme()

    const onSubmit = e => {
        if(e) e.preventDefault()
        navigate(`/search?query=${query}`)
        clear()
    }

    return (
        <div
            css={{
                display: 'flex',
                flexGrow: 1,
                marginLeft: 16,
                padding: '6px 12px 6px 16px',
                alignItems: 'center',
                border: `1px solid ${theme.colors.mutedDark}`,
                borderRadius: 48,
            }} 
            style={style}
        >
            <form onSubmit={onSubmit} css={{ flex: 1, }}>
                <input
                    id='navbar-search'
                    ref={inputRef}
                    onClick={onClick}
                    onChange={e => refine(e.target.value)}
                    value={query}
                    placeholder={clientWidth < 576 ? 'Search' : 'Search Moog'}
                    css={{
                        fontSize: 16,
                        width: '100%',
                        background: 'transparent',
                        border: 0,
                        padding: 0,
                        caretColor: 'white',
                        color: 'white',
                        '&:focus-visible': {
                            outline: 'none',
                        },
                        '::placeholder': {
                            fontSize: 13,
                        }
                    }}
                />
            </form>
            <button
                css={{
                    background: 'transparent',
                    border: 0,
                    '&:hover': {
                        cursor: 'pointer',
                    }
                }}
                onClick={() => {
                    if(onClick) onClick()
                    if(overlay === 'Search'){
                        onSubmit()
                    } else {
                        inputRef.current.focus()
                    }
                }}
            >
                <img src={searchIconWhite} alt='' />
            </button>
        </div>
    )
}
